<div class="row">
  <div class="col-lg-12">
    <div class="header_search header_search_mobile">
      <div class="title-page">Em caso afirmativo do item anterior, estime o impacto orçamentário-financeiro (R$) no
        exercício em que entrará em vigor e nos dois subsequentes:</div>
      <div class="content_search">
        <div class="new-project" *ngIf="permissoes?.canEditForm">
          <a class="btn btn-primary" type="btn" [routerLink]="novo()">Novo</a>
        </div>
      </div>
    </div>
    <div class="system-table table-container">
      <div class="system-table-conteiner">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Item</th>
              <th class="text-center">Ano 1 (Em R$)</th>
              <th class="text-center">Ano 2 (Em R$)</th>
              <th class="text-center">Ano 3 (Em R$)</th>
              <th>Metodologia utilizada</th>
              <th class="text-center width5">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of impactoList;">
              <td>{{ item.id }}</td>
              <td><span class="title-span">{{ item.title }}</span></td>
              <td class="text-center">{{ item.year_1 }}</td>
              <td class="text-center">{{ item.year_2 }}</td>
              <td class="text-center">{{ item.year_3 }}</td>
              <td>{{ item.ds_method }}</td>
              <td>
                <a class="icon-table" [routerLink]="editar(item.id)">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
              </td>
            </tr>
            <tr class="border-b-radius">
              <td colspan="2">Total</td>
              <td class="text-center">{{ totais?.total1 }}</td>
              <td class="text-center">{{ totais?.total2 }}</td>
              <td class="text-center">{{ totais?.total3 }}</td>
              <td colspan="2"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>